import React from 'react';
const forYou = ['Estás cansada de perder el tiempo con hombres inconsistentes.', 'Sueles atraer perfiles manipuladores o emocionalmente indisponibles.', 'Quieres el control de tu vida romántica y no dejarlo al azar.', 'Buscas una relación seria sin probar suerte durante meses.'];
const notForYou = ['Buscas técnicas de manipulación o conquista superficial.', 'No estás dispuesta a ser honesta con los resultados.', 'Prefieres vivir en la negación de las señales de alerta.'];
export function ForWhomSection() {
  return <section className="px-5 py-12 max-w-[640px] mx-auto" data-id="element-65">
      <span className="inline-block bg-[var(--accent)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-4 uppercase" data-id="element-66">
        PARA QUIÉN ES
      </span>

      <h2 className="text-[clamp(26px,7vw,40px)] font-extrabold leading-tight mb-2" data-id="element-67">
        Sé honesta contigo misma.
      </h2>

      <p className="text-white text-[17px] leading-relaxed mb-6" data-id="element-68">
        Este sistema no es para todas. Es para las que están listas para ver la
        verdad.
      </p>

      <div className="mt-4" data-id="element-69">
        <div className="bg-[var(--card)] rounded-2xl p-6 mb-4 border border-[var(--border)]" data-id="element-70">
          <h3 className="text-lg font-bold mb-4 pb-3 border-b border-[var(--border)]" data-id="element-71">
            Es para ti si —
          </h3>
          {forYou.map((item, index) => <div key={index} className="flex gap-3.5 mb-4 last:mb-0 items-start" data-id="element-72">
              <span className="text-[var(--red2)] font-bold text-xl mt-0.5 flex-shrink-0" data-id="element-73">
                ✓
              </span>
              <span className="text-white text-[17px] leading-relaxed" data-id="element-74">
                {item}
              </span>
            </div>)}
        </div>

        <div className="bg-[var(--card)] rounded-2xl p-6 opacity-60 border border-[var(--border)]" data-id="element-75">
          <h3 className="text-lg font-bold mb-4 pb-3 border-b border-[var(--border)] text-[var(--muted)]" data-id="element-76">
            No es para ti si —
          </h3>
          {notForYou.map((item, index) => <div key={index} className="flex gap-3.5 mb-4 last:mb-0 items-start" data-id="element-77">
              <span className="text-[var(--muted)] font-bold text-xl mt-0.5 flex-shrink-0" data-id="element-78">
                ✕
              </span>
              <span className="text-[var(--muted)] text-[17px] leading-relaxed" data-id="element-79">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}